import api, { BULK_TIMEOUT_MS } from "..";
import { playListPassword, playListUsername } from "../../../state";

const cache = new Map<string, Promise<number>>();

export default function () {
  return (): Promise<number> => {
    const username = playListUsername();
    const password = playListPassword();

    const cacheKey = `${username}_all_live_streams`;
    const url = `/player_api.php?username=${username}&password=${password}&action=get_live_streams`;

    if (cache.has(cacheKey)) {
      return cache.get(cacheKey)!;
    }

    const result = api
      ._getWithRetry(url, {}, 1, 20000, BULK_TIMEOUT_MS)
      .then(channels => {
        if (!Array.isArray(channels)) {
          // e.g. `false` from an unhealthy proxy — don't pin it as empty
          cache.delete(cacheKey);
          return 0;
        }
        return channels.length;
      })
      .catch(error => {
        console.error(`❌ All live streams API call failed:`, error.message);
        cache.delete(cacheKey);
        return 0;
      });

    cache.set(cacheKey, result);
    return result;
  };
}